import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-thunder",
  "use": "icon-thunder-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-thunder\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.985 7.26a.26.26 0 0 0-.197-.168l-3.087-.548a.204.204 0 0 1-.159-.262l1.235-3.95a.259.259 0 0 0-.436-.25l-5.277 6.39a.259.259 0 0 0 .148.425l3.044.54c.118.021.192.14.16.257l-1.13 3.982a.26.26 0 0 0 .188.316.26.26 0 0 0 .254-.077l5.21-6.4a.26.26 0 0 0 .047-.255\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol